import { FaBell, FaChevronRight, FaUser } from "react-icons/fa";
import { useLocation, matchPath, Link, useNavigate } from "react-router-dom";

import menu, { PATH_HOME } from "@/config/menu";

import * as S from "./styles";
import SwitchWorkspace from "../SwitchWorkspace";
import { useMenu } from "@/hooks/useMenu";

const isActive = (item, location) => {
  const path = location.pathname;

  if (item.href.includes("/:")) {
    const routePattern = item.href.replace(/:.*$/, "*");
    return matchPath({ path: routePattern, end: false }, path);
  }

  return matchPath({ path: item.href, end: true }, path);
};

const Header = ({ name, workspace, currentWorkspace }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { open } = useMenu();

  const handleGoToHome = () => {
    navigate("/");
  };

  const activeMenu = menu.find((item) => {
    if (isActive(item, location)) return true;

    return item.submenu?.some((subItem) => isActive(subItem, location));
  });

  const activeSubMenuItem = activeMenu?.submenu?.find((item) =>
    isActive(item, location)
  );

  return (
    <S.Container open={open}>
      <S.Left>
        <S.Logo onClick={handleGoToHome} />

        <S.BreadCrumb>
          <S.BreadCrumbItem>
            <Link to={activeMenu?.href || PATH_HOME}>{activeMenu?.title}</Link>
          </S.BreadCrumbItem>
          {activeSubMenuItem?.title && (
            <>
              <FaChevronRight size={12} color="#A0AEC0" />
              <S.BreadCrumbItem>{activeSubMenuItem.title}</S.BreadCrumbItem>
            </>
          )}
        </S.BreadCrumb>
      </S.Left>

      <S.Right>
        <S.Actions>
          <SwitchWorkspace
            workspaces={workspace}
            currentWorkspace={currentWorkspace}
          />

          <S.Item>
            <S.Avatar>
              <FaUser size={12} />
            </S.Avatar>
            <S.Name>{name}</S.Name>
          </S.Item>

          <S.Item>
            <FaBell size={14} />
            <S.Name>Notificações</S.Name>
          </S.Item>
        </S.Actions>
      </S.Right>
    </S.Container>
  );
};

export default Header;
